import { headerHeight } from "../../document/documentLayout"
import { useGlobalBanner } from "../banners/GlobalBanner"

export function useHeaderOffset() {
  const { bannerHeight } = useGlobalBanner()
  return { headerOffset: bannerHeight }
}

export function useContentOffset() {
  const { headerOffset } = useHeaderOffset()
  return { contentOffset: headerOffset + headerHeight }
}
